export default __webpack_public_path__ + "static/media/kal-visuals-square.22829a59.jpg";